import React from 'react';

const SecurityShield = ({ className }: { className?: string }): React.ReactElement => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M16.6673 9.31843C16.6673 13.1026 13.8232 16.6409 10.0007 17.5001C6.17815 16.6409 3.33398 13.1026 3.33398 9.31843V6.34593C3.33398 5.66926 3.74315 5.05926 4.36982 4.80343L8.53648 3.09843C9.47482 2.71426 10.5265 2.71426 11.4648 3.09843L15.6315 4.80343C16.2582 5.06009 16.6673 5.66926 16.6673 6.34593V9.31843V9.31843Z"
      stroke="#0DD149"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.709 8.4375L9.58398 11.5625L7.70898 9.6875"
      stroke="#0DD149"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SecurityShield;
